import { useContext } from 'react';

import { LoaderProviderContext } from '@/providers';

export const useLoader = () => useContext(LoaderProviderContext) || {};
